export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const ACTIVITY_LOG_URL = process.env.REACT_APP_ACTIVITY_LOG_API_KEY;
